import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IActionResult } from '../../../../httpClient/serverApi/types/IActionResult';
import { IMultipleIdsParams } from '../../../../spacesPlatform/utils/actionParams';

export class EnableDatabaseControlledPermissionsRequest
    extends Request<IMultipleIdsParams, IActionResult> {
  constructor(ids: string[]) {
    super('enableDatabaseControlledPermissions', {
      ids: ids
    });
  }
}

export class DisableDatabaseControlledPermissionsRequest
  extends Request<IMultipleIdsParams, IActionResult> {
  constructor(ids: string[]) {
    super('disableDatabaseControlledPermissions', {
      ids: ids
    });
  }
}
